"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Networks = void 0;
var Networks;
(function (Networks) {
    Networks["MAINNET"] = "mainnet";
    Networks["ELP"] = "elp";
    Networks["TESTNET_CLAY"] = "testnet-clay";
    Networks["DEV_UNSTABLE"] = "dev-unstable";
    Networks["LOCAL"] = "local";
    Networks["INMEMORY"] = "inmemory";
})(Networks = exports.Networks || (exports.Networks = {}));
//# sourceMappingURL=networks.js.map